import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { IResourceAllocationData } from '../type';
import ResourceAllocationCard from './resource-allocation-card';

interface PropsType {
  resourceAllocation: IResourceAllocationData[];
}

const ResourceAllocationGrid = ({
  resourceAllocation
}: PropsType): JSX.Element => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.up('md'));
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.up('sm'));

  const columns = isLargeScreen
    ? 3
    : isMediumScreen
    ? 2
    : isSmallScreen
    ? 2
    : isExtraSmallScreen
    ? 1
    : 1;

  return (
    <Grid sx={{ marginRight: 1 }} container spacing={2}>
      {[...Array(columns)].map((_value, colIndex) => (
        <Grid key={colIndex} item xs={12} sm={12} md={6} lg={6} xl={4}>
          {resourceAllocation
            .filter((_, index) => index % columns === colIndex)
            .map((resourceAllocations) => (
              <Grid
                key={resourceAllocations.member.id}
                item
                xs={12}
                sx={{
                  marginBottom: 2
                }}
              >
                <ResourceAllocationCard
                  resourceAllocations={resourceAllocations}
                />
              </Grid>
            ))}
        </Grid>
      ))}
    </Grid>
  );
};

export default ResourceAllocationGrid;
